import type { SVGProps } from 'react'

export const YoutubeMonochromeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
    focusable={false}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.033 6.376a2.26 2.26 0 0 1 1.592 1.596C21 9.38 21 12.316 21 12.316s0 2.937-.375 4.343a2.261 2.261 0 0 1-1.592 1.597c-1.403.376-7.033.376-7.033.376s-5.627 0-7.033-.377a2.26 2.26 0 0 1-1.592-1.596C3 15.253 3 12.316 3 12.316s0-2.937.375-4.344a2.26 2.26 0 0 1 1.592-1.596C6.373 6 12 6 12 6s5.63 0 7.033.376Zm-4.155 5.94-4.676 2.707V9.609l4.676 2.707Z"
      clipRule="evenodd"
    />
  </svg>
)
